import {Swal, Alert, FC} from 'external/react'
import usePackage from 'context/package-context/hook'
import Icon from 'external/fortawesome'

export async function studentAssignmentWarning() {
	const {isConfirmed} = await Swal.fire({
			text: 'La asignación del estudiante es irreversible, si estás seguro de aplicar esta asignación puedes continuar.',
			icon: 'warning',
			showCancelButton: false,
			confirmButtonColor: '#1797D0',
			cancelButtonColor: '#e9e9e9',
			confirmButtonText: 'Confirmar Asignación',
			showCloseButton: true,
			reverseButtons: true,
		})
    return isConfirmed
}

export const StudentAssignmentWarning: FC = () => {
    const {update, state: {modals}} = usePackage()
    return (
        <Alert
            show={modals.studentAssignmentWarning.open}
            variant='warning'
            onClose={() => update({modals: {studentAssignmentWarning: {open: {$set: false}}}})}
            className='alert--alert'
            dismissible
        >
            <Alert.Heading>
                <span style={{ fontSize: '14px' }}><Icon name='faCircleExclamation' />
                Recuerda, la asignación del estudiante es irrevocable, ante algún error deberá comunicarse con el equipo de soporte. </span>
            </Alert.Heading>
        </Alert>
    )
}